import {
  CSSProperties,
  ReactNode,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  DiagonalLine,
  LeftItemContainer,
  RightItemContainer,
  TriangleContainer,
} from "./TriangleContent.styled";
import { useTheme } from "../../../../hooks";
import { rem } from "@mantine/core";

interface DynamicTriangleHeaderProps {
  data: (string | ReactNode)[];
  rowSpan?: number;
  minHeight?: number;
  minWidth?: number;
  isInput?: boolean;
  coloredText?: boolean;
}

const TriangleContent = ({
  data,
  rowSpan = 1,
  minHeight = 40,
  minWidth = 90,
  isInput,
  coloredText,
}: DynamicTriangleHeaderProps) => {
  const theme = useTheme();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [dimensions, setDimensions] = useState({ width: 120, height: 70 });
  const [mounted, setMounted] = useState(isInput);
  useEffect(() => {
    if (containerRef.current) {
      const updateDimensions = () => {
        setDimensions({
          width: containerRef.current?.offsetWidth ?? 0,
          height: containerRef.current?.offsetHeight ?? 0,
        });
      };
      updateDimensions();
      setMounted(true);
      // window.addEventListener("resize", updateDimensions);
      // const resizeObserver = new ResizeObserver(() => {
      //   updateDimensions();
      // });
      // resizeObserver.observe(containerRef.current);
      // return () => {
      //   window.removeEventListener("resize", updateDimensions);
      //   resizeObserver.disconnect();
      // };
    }
  }, []);

  const { leftTriangleStyle, rightTriangleStyle } = useMemo(() => {
    const multipliers = isInput ? [0.2, 0.08, 0.65] : [0.25, 0.15, 0.45];
    return {
      leftTriangleStyle: {
        top: dimensions.height * multipliers[0],
        left: dimensions.width * multipliers[1],
        maxWidth: dimensions.width * multipliers[2],
        transform: "translate(-25%, -50%)",
        color: coloredText ? theme.colors.text[0] : theme.colors.thColor[0],
      },

      rightTriangleStyle: {
        bottom: dimensions.height * multipliers[0],
        right: dimensions.width * multipliers[1],
        maxWidth: dimensions.width * multipliers[2],
        transform: "translate(25%, 50%)",
        color: coloredText ? theme.colors.text[0] : theme.colors.thColor[0],
      },
    } as Record<string, CSSProperties>;
  }, [dimensions, isInput, coloredText]);

  return (
    <TriangleContainer
      ref={containerRef}
      style={{
        position: rowSpan > 1 ? "absolute" : "relative",
        minHeight: rem(minHeight),
        minWidth: rem(minWidth),
      }}>
      {mounted && (
        <>
          <DiagonalLine>
            <svg
              width="100%"
              height="100%"
              style={{ position: "absolute", top: 0, left: 0 }}>
              <path
                d={`M 0,${dimensions.height} L ${dimensions.width},0`}
                stroke={
                  isInput
                    ? theme?.colors?.inputBorder[0]
                    : theme?.colors?.thBorder[0]
                }
                strokeWidth="1.5"
                fill="none"
              />
            </svg>
          </DiagonalLine>
          {data?.length > 1 && (
            <>
              <LeftItemContainer style={leftTriangleStyle}>
                {data[0]}
              </LeftItemContainer>

              <RightItemContainer style={rightTriangleStyle}>
                {data[1]}
              </RightItemContainer>
            </>
          )}
        </>
      )}
    </TriangleContainer>
  );
};

export default TriangleContent;
